"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const BG_URL = "https://getgeek-website-assets.b-cdn.net/ScoutDoesBg.webp";

const WhatZaynDoesSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  // mobile/tablet: left (LTR) or right (Arabic), desktop: centered
  const textAlign = { xs: isArabic ? "right" : "left", md: "center" };

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 3, md: 7 },
        direction: isArabic ? "rtl" : "ltr",
        backgroundImage: `url(${BG_URL})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px", sm: "28px", md: "32px" },
            fontWeight: 700,
            lineHeight: 1.3,
            color: "#14122B",
            fontFamily: "var(--font-plusjakarta)",
            textAlign,
            mb: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {t("whatZaynDoes.title")}
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            color: "#55556E",
            lineHeight: 1.8,
            fontWeight: 400,
            fontFamily: "var(--font-outfit)",
            textAlign,
            maxWidth: 720,
            mx: { xs: 0, md: "auto" },
          }}
        >
          {t("whatZaynDoes.description")}
        </Typography>
      </Container>
    </Box>
  );
};

export default WhatZaynDoesSection;